
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industry-real-estate-and-property-management",
      function () {
        return require("private-next-pages/industry-real-estate-and-property-management.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industry-real-estate-and-property-management"])
      });
    }
  